import React from "react";
import { Navigate } from "react-router-dom";

function LoginRoute({ children, redirectTo, getCookie }) {

	const cookie = getCookie( 'loggedIn' );

	const isAuthenticated = ( cookie === 'true' ) ? true : false;

	// console.log("this", isAuthenticated);

	return isAuthenticated ? <Navigate to={redirectTo} /> : children;

}

export default LoginRoute;